/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Message_DeadInputs */

const en_sync_message_dead = /** @type {(inputs: Sync_Message_DeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not delivered`)
};

/**
* | output |
* | --- |
* | "Not delivered" |
*
* @param {Sync_Message_DeadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_message_dead = /** @type {((inputs?: Sync_Message_DeadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Message_DeadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_message_dead(inputs)
});